import { useField } from "formik";
import {
  InputField,
  EfsMelcoEfsModelsFormat,
  SaveFormButton,
} from "melco-shared-logic";
import { Title } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Attributes } from "./Attributes";

type LetteringDataMappingProps = {
  inputFormat: EfsMelcoEfsModelsFormat;
};

export const LetteringDataMapping: React.FC<LetteringDataMappingProps> = ({
  inputFormat,
}) => {
  const { t } = useTranslation();

  const [{ value: type }] = useField("config_type");

  if (type !== "Lettering") {
    return null;
  }

  return (
    <>
      <InputField name="name" label={t("dataMappings.form.label.name")} />

      <Title level={5}>{t(`dataMappings.form.titles.text`)}</Title>

      <Attributes
        dataAssignments={inputFormat.schema_list ?? []}
        attribute="_text"
      />

      <Title level={5}>{t(`dataMappings.form.titles.color`)}</Title>

      <Attributes
        dataAssignments={inputFormat.schema_list ?? []}
        attribute="_color"
      />

      <Title level={5}>{t(`dataMappings.form.titles.font`)}</Title>

      <Attributes
        dataAssignments={inputFormat.schema_list ?? []}
        attribute="_font"
      />

      <SaveFormButton />
    </>
  );
};
